import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchAvailableStudyReports = async (trialId) => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${__API_URL__}/api/reports/study_report/available/${trialId}/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return { reports: res.data.reports, activeRequest: res.data.active_request };
};

const useAvailableStudyReports = ({ trialId, enabled = true }) =>
  useQuery({
    queryKey: ["available-study-reports", trialId],
    queryFn: () => fetchAvailableStudyReports(trialId),
    enabled: enabled && Boolean(trialId),
  });

export default useAvailableStudyReports;
